import { IPostingCreatedBy } from '../interfaces/interfaces/posting-created-by.query.interface';

export class PostingCreatedBy {
    id: string;
    firstName: string;
    lastName: string;

    constructor(postingQuery?: IPostingCreatedBy) {
        this.id = postingQuery.id.toString();
        this.firstName = postingQuery.first_name;
        this.lastName = postingQuery.last_name;
    }
}
